import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import brokerCompanyApi from '../../services/brokerCompanyApi';
import BrokerCompanyDetail from '../../components/broker/BrokerCompanyDetail';
import { useToast } from '../../components/shared/Toast';
import EmptyState from '../../components/shared/EmptyState';
import LoadingSkeleton from '../../components/shared/LoadingSkeleton';
import { authService } from '../../services/authService';
import { Roles } from '../../constants';

const BrokerManageCompanyPage = () => {
  const { data: broker, isLoading: brokerLoading } = brokerCompanyApi.endpoints.getMyCompany.useQuery();
  const { data: offices = [], isLoading: officesLoading } = brokerCompanyApi.endpoints.getMyCompanyOffices.useQuery();
  const { data: users = [], isLoading: usersLoading } = brokerCompanyApi.endpoints.getMyCompanyUsers.useQuery();
  const [updateMyCompany] = brokerCompanyApi.endpoints.updateMyCompany.useMutation();
  const [addOffice] = brokerCompanyApi.endpoints.addSatelliteOffice.useMutation();
  const [inviteUser] = brokerCompanyApi.endpoints.inviteBrokerUser.useMutation();
  const [editUser] = brokerCompanyApi.endpoints.editUser.useMutation();
  const [deleteUserMutation] = brokerCompanyApi.endpoints.deleteUser.useMutation();
  const [editOfficeMutation] = brokerCompanyApi.endpoints.editOffice.useMutation();
  const [resendConfirmation] = brokerCompanyApi.endpoints.resendConfirmation.useMutation();

  const { showToast, ToastContainer } = useToast();
  const currentUser = authService.getCurrentUser();
  const isProcessor = currentUser?.role === Roles.Processor;
  const loading = brokerLoading || officesLoading || usersLoading;

  if (loading) {
    return <LoadingSkeleton variant="detail" />;
  }

  if (!broker) {
    return (
      <EmptyState
        icon={<ErrorOutlineIcon />}
        title="Company not found"
        description="Your account is not associated with a broker company."
      />
    );
  }

  const handleUpdateCompany = async (form) => {
    await updateMyCompany(form).unwrap();
  };

  const handleAddOffice = async (form) => {
    await addOffice(form).unwrap();
  };

  const handleInviteUser = async (form) => {
    await inviteUser({ ...form, brokerCompanyId: broker?.id }).unwrap();
  };

  const handleEditUser = async (form) => {
    await editUser({ ...form, brokerCompanyId: broker?.id }).unwrap();
  };

  const handleDeleteUser = async (user) => {
    await deleteUserMutation({ userId: user.userId, brokerCompanyId: broker?.id }).unwrap();
  };

  const handleEditOffice = async (form) => {
    await editOfficeMutation({ ...form, brokerCompanyId: broker?.id }).unwrap();
  };

  const handleResendInvite = async (user) => {
    try {
      await resendConfirmation({ userId: user.userId }).unwrap();
      showToast(`Confirmation email resent to ${user.emailAddress}.`);
    } catch {
      showToast('Failed to resend confirmation email.', 'danger');
    }
  };

  return (
    <>
    {ToastContainer}
    <BrokerCompanyDetail
      broker={broker}
      offices={offices}
      users={users}
      mode="broker"
      onUpdateCompany={isProcessor ? undefined : handleUpdateCompany}
      onAddOffice={isProcessor ? undefined : handleAddOffice}
      onInviteUser={isProcessor ? undefined : handleInviteUser}
      onEditUser={isProcessor ? undefined : handleEditUser}
      onDeleteUser={isProcessor ? undefined : handleDeleteUser}
      onEditOffice={isProcessor ? undefined : handleEditOffice}
      onResendInvite={isProcessor ? undefined : handleResendInvite}
      canEditNmls={false}
    />
    </>
  );
};

export default BrokerManageCompanyPage;
